import axios from 'axios';
import config from '../../config';
import tokenApi from './tokenApi';

// import tokenApi from './tokenApi';

const questionsInstance = axios.create({
	baseURL: config.api,
    headers: {
		'Content-Type': 'application/json'
	}
});

// const parseStorage = JSON.parse(localStorage.u);

class QuestionsApi {

	static InfoList() {
		return questionsInstance.get('/option')
		.then(function (response) {
            // console.log(response)
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	};

	static InfoSubmit(payload){
		// console.log(payload);
		const token=tokenApi.GetToken();
		
		return questionsInstance.post('/student/info/'+token.student["_id"],payload)
		.then(function (response) {
			// console.log("success");
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	};

	static DreamSubmit(payload){
		// console.log(payload);
		const token=tokenApi.GetToken();
		return questionsInstance.post('/student/daydream/'+token.student["_id"],payload)
		.then(function (response) {
			// console.log("success");
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	};
	
	static QuestionsList() {
	
		const token=tokenApi.GetToken();
		// console.log(token);
		return questionsInstance.get('student/current/'+token.student["_id"])
		.then ( response => {
			// console.log(response.data);
			return response.data;
		})
		.catch(error =>{
			throw(error);
		})
	}

	static QuestionsSubmit(payload){
		// console.log(payload);
		const token=tokenApi.GetToken();
		return questionsInstance.post('/student/question/'+token.student["_id"],payload)
		.then(function (response) {
			// console.log("success");
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	};
    
}

export default QuestionsApi;